import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "min-h-full flex items-center justify-center"
};
import { Notification } from "@/modules/notifications/entity";
import { app } from "@/di";
import { EventEmitter } from "@/modules/base/events";
import { AfterNotifyEvent } from "@/modules/notifications/events/AfterNotifyEvent";
import NotificationComponent from "./Notification.vue";
import SimpleActionSheet from "@/modules/vue/components/SimpleActionSheet.vue";
import SimpleActionSheetItem from "@/modules/vue/components/SimpleActionSheetItem.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationTabbarItem',
  async setup(__props) {
    let __temp, __restore;
    const showPopup = ref(false);
    const notifications = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      notifications.value = await Notification.createQueryBuilder('notification').where('notification.read = false').orderBy('notification.createdAt', 'DESC').addOrderBy('notification.id', 'DESC').take(10).getMany();
    })), __temp = await __temp, __restore(), __temp);
    const hasUnread = computed(() => notifications.value.length > 0);
    const actionSheet = ref(null);
    const markAsRead = async notification => {
      notification.read = true;
      await notification.save();
      await refresh();
    };
    const markAllAsRead = async () => {
      const notifications = await Notification.createQueryBuilder('notification').where('notification.read = false').getMany();
      await notifications.forEachAsync(async n => {
        n.read = true;
        await n.save();
      });
      await refresh();
    };
    onBeforeUnmount(app.get(EventEmitter).onOff(AfterNotifyEvent, refresh));
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NEmpty = _resolveComponent("NEmpty");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(_component_NButton, {
        text: "",
        class: _normalizeClass({
          'text-green-600': _unref(hasUnread)
        }),
        onClick: _cache[1] || (_cache[1] = () => _ctx.$refs.actionSheet.show())
      }, {
        default: _withCtx(() => [_createVNode(_component_Icon, {
          icon: _unref(hasUnread) ? _ctx.IconEnum.Notifications : _ctx.IconEnum.NotificationsOutline
        }, null, 8, ["icon"]), _createVNode(SimpleActionSheet, {
          ref_key: "actionSheet",
          ref: actionSheet,
          "no-teleport": ""
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('notifications')), 1)]),
          actions: _withCtx(() => [notifications.value.length > 0 ? (_openBlock(), _createBlock(SimpleActionSheetItem, {
            key: 0,
            onClick: markAllAsRead
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('mark_all_as_read')), 1)]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(SimpleActionSheetItem, {
            to: {
              name: 'notifications.index'
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('show_all_notifications')), 1)]),
            _: 1
          }, 8, ["to"])]),
          default: _withCtx(() => [notifications.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NEmpty, {
            description: _ctx.$t('no_unread_notifications')
          }, null, 8, ["description"])])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(notifications.value, notification => {
            return _openBlock(), _createBlock(NotificationComponent, {
              key: notification.id,
              notification: notification,
              class: "border-b last:border-b-0",
              onDelete: $event => markAsRead(notification),
              onClickedSee: _cache[0] || (_cache[0] = $event => showPopup.value = false)
            }, null, 8, ["notification", "onDelete"]);
          }), 128))]),
          _: 1
        }, 512)]),
        _: 1
      }, 8, ["class"]);
    };
  }
});